"use client";

import React from "react";

// Locale-aware copy. Hindi versions ship to /hi/kundli-matching where
// English H1+kicker on a Hindi-titled page caused a Google language-mismatch
// signal (audit 2026-05-09: -85% impressions on /hi/kundli-matching). Default
// stays English so /kundli-matching is unchanged.
const COPY = {
  en: {
    kicker: "Ashtakoot Gun Milan",
    h1: "Free Kundli Matching Online",
    sub: "Enter birth details of boy and girl to get complete 36-point Gun Milan score, all 8 Koota breakdown, Mangal Dosha check, and marriage compatibility — 100% free.",
    accurate: "100% Accurate",
    instant: "Instant Results",
    free: "100% Free",
  },
  hi: {
    kicker: "अष्टकूट गुण मिलान",
    h1: "मुफ़्त कुंडली मिलान — गुण मिलान ऑनलाइन",
    sub: "लड़के और लड़की की जन्म विवरण दर्ज करें — पूरा 36 गुण मिलान, सभी 8 कूट विश्लेषण, मांगलिक दोष जांच और विवाह अनुकूलता — 100% निःशुल्क।",
    accurate: "100% सटीक",
    instant: "तुरंत परिणाम",
    free: "100% निःशुल्क",
  },
} as const;

export function Header({ locale = "en" }: { locale?: "en" | "hi" }) {
  const copy = COPY[locale];
  return (
    <div className="text-center mb-10">
      <p className="text-[11px] font-semibold uppercase tracking-[0.25em] mb-3 text-ish-accent">
        {copy.kicker}
      </p>
      <h1 className="text-[28px] sm:text-[36px] font-bold leading-tight text-ish-dark font-serif">
        {copy.h1}
      </h1>
      <p className="mt-3 text-[15px] leading-relaxed max-w-lg mx-auto text-ish-text-muted">
        {copy.sub}
      </p>

      {/* Trust signals */}
      <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-medium text-ish-text-faint">
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          {copy.accurate}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          {copy.instant}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          {copy.free}
        </span>
      </div>
    </div>
  );
}
